export class FactorReportFilter {
  public constructor() {
  }

  public FactorDateFrom?: string;
  public FactorDateTo?: string;
  public DeliverDateFrom?: string;
  public DeliverDateTo?: string;
  public AddedDateFrom?: string;
  public AddedDateTo?: string;
  
  public TotalPriceFrom?: string;
  public TotalPriceTo?: string;
  public DiscountFrom?: string;
  public DiscountTo?: string;
  
  public HasReturn?: boolean;
  public HasStorage?: boolean;
  public Paid?: boolean;
  public OnPayment?: boolean;
  public NoPayment?: boolean;
}

